import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="bg-charcoal-900 text-white pt-24 pb-12 relative overflow-hidden" data-id="element-90">
      {/* Top Border Pattern */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold via-earth-terracotta to-gold" data-id="element-91" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-92">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-93">
          <div className="col-span-1 md:col-span-2" data-id="element-94">
            <h2 className="text-3xl font-sans font-black text-white mb-6" data-id="element-95">
              AFRICAN <span className="text-gold" data-id="element-96">FOUNDERS</span>
            </h2>
            <p className="font-serif text-archival-muted max-w-md text-lg leading-relaxed" data-id="element-97">
              {t('footer.desc')}
            </p>
          </div>

          <div data-id="element-98">
            <h4 className="font-mono text-gold text-sm uppercase tracking-widest mb-6 font-bold" data-id="element-99">
              {t('footer.collection')}
            </h4>
            <ul className="space-y-4 font-sans text-archival-off" data-id="element-100">
              <li data-id="element-101">
                <a href="#episodes" className="hover:text-gold transition-colors" data-id="element-102">
                  {t('footer.latest')}
                </a>
              </li>
              <li data-id="element-103">
                <a href="#about" className="hover:text-gold transition-colors" data-id="element-104">
                  {t('footer.about')}
                </a>
              </li>
              <li data-id="element-105">
                <a href="#founders" className="hover:text-gold transition-colors" data-id="element-106">
                  {t('footer.index')}
                </a>
              </li>
              <li data-id="element-107">
                <a href="https://podcasts.apple.com/sn/podcast/the-african-founder/id1888801055" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-108">
                  {t('footer.series')}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-109">
            <h4 className="font-mono text-gold text-sm uppercase tracking-widest mb-6 font-bold" data-id="element-110">
              {t('footer.connect')}
            </h4>
            <ul className="space-y-4 font-sans text-archival-off" data-id="element-111">
              <li data-id="element-112">
                <a href="https://www.youtube.com/@TheAfricanFounder" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-113">
                  YouTube
                </a>
              </li>
              <li data-id="element-114">
                <a href="https://www.linkedin.com/company/the-african-founder/" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-115">
                  LinkedIn
                </a>
              </li>
              <li data-id="element-116">
                <a href="https://open.spotify.com/show/52WTkt0615T5fvMp7wZS69" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-117">
                  Spotify
                </a>
              </li>
              <li data-id="element-118">
                <a href="https://podcasts.apple.com/sn/podcast/the-african-founder/id1888801055" target="_blank" rel="noopener noreferrer" className="hover:text-gold transition-colors" data-id="element-119">
                  Apple Podcasts
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-charcoal-700 pt-8 flex justify-center md:justify-start items-center text-sm text-archival-muted font-mono" data-id="element-120">
          <p data-id="element-121">{t('footer.rights')}</p>
        </div>
      </div>

      {/* Background Watermark */}
      <div className="absolute bottom-0 right-0 opacity-5 pointer-events-none" data-id="element-122">
        <svg width="400" height="400" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-123">
          <circle cx="50" cy="50" r="40" stroke="white" strokeWidth="2" data-id="element-124" />
          <circle cx="50" cy="50" r="30" stroke="white" strokeWidth="2" data-id="element-125" />
          <path d="M50 10 V90 M10 50 H90" stroke="white" strokeWidth="2" data-id="element-126" />
        </svg>
      </div>
    </footer>;
}